import React from 'react'
import { Parallax, ParallaxProvider } from 'react-scroll-parallax'
import classnames from 'classnames'

import {
  backGround,
  logoCircles,
  logoCirclesCont,
  logoCirclesCr,
  wave,
  waveCont,
  waveRow,
  waveCircle,
} from './ParallaxBackground.module.scss'

const ParallaxBackground = () => {
  const Wave = () => {
    return (
      <div className={wave}>
        {[...Array(12)].map((x, i) => {
          return (
            <div key={i} className={classnames(waveRow, `r-${i + 1}`)}>
              {[...Array(9)].map((y, j) => {
                return <div key={j} className={waveCircle} />
              })}
            </div>
          )
        })}
      </div>
    )
  }

  const LogoCircles = () => {
    return (
      <div className={logoCircles}>
        {[...Array(3)].map((c, idx) => {
          return (
            <div
              key={idx}
              className={classnames(logoCirclesCr, `cr-${idx + 1}`)}
            />
          )
        })}
      </div>
    )
  }

  return (
    <ParallaxProvider>
      <div className={backGround}>
        <Parallax className={logoCirclesCont} speed={-20}>
          <LogoCircles />
        </Parallax>
        <Parallax className={waveCont} speed={-10}>
          <Wave />
        </Parallax>
      </div>
    </ParallaxProvider>
  )
}

export default ParallaxBackground
